import React from 'react';
import { XIcon, EyeIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
const symptoms = ['Improvising every estimate.', 'Charging without knowing their actual profit.', 'Dealing with customers without a clear process.', 'Wasting hours looking for tools, parts or paperwork.', 'Forgetting to follow up with customers.', 'Giving away warranty work.', 'Starting every month from zero.'];
const signals = ['How you quote a repair.', 'How you present a service order.', 'How you explain your warranty.', 'How organized your process is.', 'How you follow up.', 'How much confidence you inspire.'];
export function Problem() {
  return <Section tone="darker" data-id="element-221" data-mp="23s0vuxx4sh51">
      <Eyebrow data-id="element-222" data-mp="23ssru9un4gvu">The real problem</Eyebrow>
      <Heading data-id="element-223" data-mp="6yfuy1931ltj">
        The problem isn’t that you don’t know how to repair appliances
      </Heading>

      <p className="mx-auto mt-4 max-w-2xl text-center text-[16px] font-semibold leading-relaxed text-gold-400 sm:text-xl" data-id="element-224" data-mp="204j5kz8918o">
        The problem is that you’re still working like a technician… when you
        could be operating like a business owner.
      </p>

      <div className="mt-6 space-y-3 text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-225" data-mp="vadn9l28kjan">
        <p data-id="element-226" data-mp="vcq9iaf11fti">
          Most appliance repair technicians spend years learning how to diagnose
          and repair washers, dryers, refrigerators and other appliances.
        </p>
        <p data-id="element-227" data-mp="1nzuj6sp2eibm">
          But almost nobody teaches them how to run the business behind the
          repairs.
        </p>
        <p className="font-semibold text-white" data-id="element-228" data-mp="1s2ha8rdwvz7r">
          And that’s why so many technicians end up…
        </p>
      </div>

      <ul className="mt-5 space-y-2" data-id="element-229" data-mp="1j7szwmthbrc3">
        {symptoms.map(item => <li key={item} className="flex items-start gap-3 rounded-lg border border-red-500/20 bg-red-950/25 px-3 py-3" data-id="element-230" data-mp="26xx4oxielx4o">
            <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-231" data-mp="2bq6r43kb8f27" />
            <span className="text-[14px] leading-snug text-white/85 sm:text-base" data-id="element-232" data-mp="2li9nsqmjq804">
              {item}
            </span>
          </li>)}
      </ul>

      <div className="mt-6 border-l-4 border-gold-500 pl-4" data-id="element-233" data-mp="2blemy12svvio">
        <p className="font-display text-[22px] font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-234" data-mp="26nll1k8j5no7">
          They work more. They get more exhausted.
        </p>
        <p className="mt-1 font-display text-[22px] font-bold uppercase leading-tight text-gold-500 sm:text-3xl" data-id="element-235" data-mp="22numuvgoc59n">
          But they don’t earn what they should.
        </p>
      </div>

      <div className="mt-10 rounded-2xl border border-white/10 bg-navy-900 p-5 sm:p-7" data-id="element-236" data-mp="1swgk8etfepca">
        <div className="flex items-center gap-2" data-id="element-237" data-mp="1ny6oa1zvnkpm">
          <EyeIcon className="h-5 w-5 text-gold-500" aria-hidden="true" data-id="element-238" data-mp="1ixiwvf7ql1uv" />
          <p className="font-display text-[13px] font-bold uppercase tracking-[0.12em] text-gold-500" data-id="element-239" data-mp="1izv9dcuq6k0j">
            What customers really notice
          </p>
        </div>
        <h3 className="mt-2 font-display text-[26px] font-extrabold uppercase leading-[1.05] text-white sm:text-4xl" data-id="element-240" data-mp="3qir60z846cxt">
          Your customers can’t always tell who is the best technician…
        </h3>
        <p className="mt-3 text-[16px] font-semibold text-gold-400 sm:text-xl" data-id="element-241" data-mp="3fckgkxcks67">
          But they can tell who looks more professional.
        </p>

        <p className="mt-4 text-[14px] font-semibold uppercase tracking-wide text-white/60" data-id="element-242" data-mp="36vteig4pyyl7">
          They notice:
        </p>
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-243" data-mp="3bvo5sksepq6s">
          {signals.map(signal => <li key={signal} className="rounded-lg bg-navy-950 px-3 py-2.5 text-[14px] leading-snug text-white/85 sm:text-base" data-id="element-244" data-mp="3gtg01lgixoe5">
              {signal}
            </li>)}
        </ul>

        <p className="mt-5 text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-245" data-mp="2o4s7r5xcxyr3">
          And the technician who looks and operates more professionally has a
          much easier time earning trust, getting referrals, creating repeat
          customers and defending the value of their service.
        </p>
      </div>

      <div className="mt-8" data-id="element-246" data-mp="uki8qocl3ao1">
        <CTAButton label="I want to stop improvising" data-id="element-247" data-mp="18e9d7ibgk4cw" />
      </div>
    </Section>;
}